module.exports = __webpack_public_path__ + "static/icon_color_hiking_nag-51f7fbfc73683abc4dbd1cdf025797c4.png";